








import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { ExStore } from 'vuex'
import {
  WebSocketCallMessageTypes,
  VideoCallDeniedReasonCode
} from '@/websocket/receivers/call'
import WebRTCProvider, { WebRTC } from '@/webrtc'
import WebSocketProvider from '@/websocket'
import { WebSocketMessageMode } from '@/websocket/constants'
import { WebSocketClientInterface } from '@/websocket/types'
import { WebSocketEventTypes } from '@/websocket/constants'
import { FromUser } from '@/websocket/receivers/call/receiveMessages'
import { Occupation } from '@/types/user'

@Component
export default class VideoCallReceive extends Vue {
  @Prop(String) roomId!: string
  @Prop(String) pin!: string
  @Prop(String) secret!: string
  @Prop({ default: false }) videoEnable!: boolean
  @Prop() fromUser!: FromUser
  @Prop() fromOccupation!: Occupation

  $store!: ExStore
  webSocket!: WebSocketClientInterface
  webrtc: WebRTC | null = null

  get user() {
    return this.$store.getters['user/userInfo']
  }

  get isRelative() {
    return this.user.isPatientRelative
  }

  get routePrefix() {
    return this.isRelative ? 'Relative' : 'Patient'
  }

  get isCalling() {
    return this.$store.getters['videoCallRoom/isCalling']
  }

  async created() {
    await this.checkIsValidLogin()

    this.$store.dispatch('videoCallRoom/setInCallWebView')

    this.webSocket = WebSocketProvider.createConnection()

    if (this.webSocket.readyState === WebSocket.OPEN) {
      this.waitingVideoRoomReady()
    } else {
      this.webSocket.addListener(WebSocketEventTypes.OPEN, (event: Event) => {
        this.waitingVideoRoomReady()
      })
    }
    this.$postMessage.addEventListener('activateApp', () => {
      this.webSocket = WebSocketProvider.createConnection()
    })
  }

  async checkIsValidLogin() {
    try {
      await this.$api.user.fetch()
    } catch (e) {
      const name = this.user.isPatient ? 'PatientLogin' : 'Login'
      this.$router.replace({ name })
    }
  }

  waitingVideoRoomReady() {
    if (this.user.isPatient || this.user.isPatientRelative)
      this.$router.push({ name: `${this.routePrefix}Call` })
    const unsubscribe = this.$store.subscribe(({ type, payload }) => {
      if (type === 'videoCallRoom/setVideoRoomReady' && payload) {
        this.callAccept()
        unsubscribe()
      }
    })
  }

  async callAccept() {
    if (!this.roomId || !this.pin || !this.secret) {
      this.$router.replace({ name: 'Home' })
    }

    this.$store.commit('videoCallRoom/setCaller', this.fromUser)
    this.$store.commit('videoCallRoom/setCallerOccupation', this.fromOccupation)
    this.$store.commit('videoCallRoom/videoActive', this.videoEnable)

    const { roomId, secret, pin } = this

    await this.$store.dispatch('videoCallRoom/setAsCallee', {
      roomId,
      roomSecret: secret,
      pinCode: pin
    })

    this.webSocket.send(WebSocketMessageMode.CALL, {
      type: WebSocketCallMessageTypes.ACCEPTED,
      roomId
    })

    await WebRTCProvider.createConnection(
      this.user.videoApiSecret,
      this.roomId,
      this.pin,
      this.secret,
      this.videoEnable
    )

    this.$store.commit('videoCallRoom/switchCalling', true)
  }
}
